import React from 'react'
import { Select } from '@nextui-org/react'

function SelectElement({
    label = '',
    children,
    variant = 'bordered',
    size = 'md',
    color = 'primary',
    selectionMode = 'single',
    placeholder = 'Select an option',
    selectedKeys = [],
    isDisabled = false,
    onChange = () => {},
}) {
    return (
        <Select
            label={label}
            variant={variant}
            size={size}
            color={color}
            selectionMode={selectionMode}
            placeholder={placeholder}
            classNames={{
                label: 'text-black font-semibold dark:text-white',
                errorMessage:
                    'text-red-500 dark:text-red-500 font-semibold text-left mt-1',
                input: 'text-black font-semibold dark:text-white',
            }}
            selectedKeys={selectedKeys}
            isDisabled={isDisabled}
            onChange={onChange}
        >
            {children}
        </Select>
    )
}

export default SelectElement
